import { JSX } from "react";
import { Navigate } from "react-router-dom";

const isAuthenticated = () => {
  return !!sessionStorage.getItem("token"); // or use auth context
};

const PublicRoute = ({ children }: { children: JSX.Element }) => {
  return isAuthenticated() ? <Navigate to="/kc/orders" /> : children;
};

export default PublicRoute;
